import webBiLogger from '@wix/web-bi-logger';
import initSchemaLogger, { Logger } from '@wix/bi-logger-gdpr';
import { getMandatoryBIFields } from '@wix/business-manager-api';

export let logger: Logger;

export const initLogger = (msid: string) => {
  logger = initSchemaLogger(
    webBiLogger.factory().updateDefaults({
      ...getMandatoryBIFields(),
      msid,
    }),
  )();
};
